import { StoreInterface } from "@/assets/interfaces";
import { useEffect, useMemo, useState } from "react";
import { createContainer } from "unstated-next";

export enum VisitRoute {
  SLUG = "SLUG",
  SUB_DOMAIN = "SUB_DOMAIN",
  CUSTOM_DOMAIN = "CUSTOM_DOMAIN",
}

const useStorefrontContext = (data: { route: VisitRoute }) => {
  const [visitRoute, setVisitRoute] = useState<VisitRoute>(data.route);

  useEffect(() => {
    setVisitRoute(data.route);
  }, [data.route]);

  const getPaths = (store: StoreInterface) => {
    if (visitRoute === VisitRoute.SLUG) {
      return {
        home: `/${store?.slug}`,
        products: `/${store?.slug}/products`,
      };
    }

    return {
      home: `/`,
      products: `/products`,
    };
  };

  console.log({ visitRoute });

  return {
    visitRoute,
    getPaths,
  };
};

const StorefrontContext = createContainer(useStorefrontContext);

export default StorefrontContext;
